'use-client';
import * as React from 'react';
import type { VerticalLineProps } from '../VerticalLine';
import type { IVerticalLineProps } from '../../../VerticalLine.types';
import VerticalLine from '../../VerticalLine';
import skinsStyle from './styles/VerticalFadeNotchLeftLine.scss';
import { BaseVerticalLine } from './BaseVerticalLine';

const VerticalFadeNotchLeftLineSkin: React.FC<VerticalLineProps> = props => (
  <BaseVerticalLine {...props} skinsStyle={skinsStyle} />
);

const VerticalFadeNotchLeftLine: React.FC<
  Omit<IVerticalLineProps, 'skin'>
> = props => {
  return <VerticalLine {...props} skin={VerticalFadeNotchLeftLineSkin} />;
};

export default VerticalFadeNotchLeftLine;
